import React from "react";
import ReservationsDashboardWidget from "../ReservationsDashboardWidget/ReservationsDashboardWidget";
import HousekeepingDashboardWidget from "../HousekeepingDashboardWidget/HousekeepingDashboardWidget";
import RatesDashboardWidget from "../RatesDashboardWidget/RatesDashboardWidget";
import UserDashboardDisplay from "./UserDashboardDisplay";
import UserDashboardDropdown from "./UserDashboardDropdown";
import DailyRentalsDashboardWidget from "../DailyRentalsDashboardWidget/DailyRentalsDashboardWidget";

class UserDashboard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dashboard_id:
        this.props.dashboards && this.props.dashboards.length > 0
          ? this.props.dashboards[0].id
          : "",
    };

    this.widgets = {
      reservations: ReservationsDashboardWidget,
      housekeeping: HousekeepingDashboardWidget,
      rates: RatesDashboardWidget,
      daily_rentals: DailyRentalsDashboardWidget,
    };

    this.onChangeDashboard = this.onChangeDashboard.bind(this);
  }

  render() {

    
    var dashboard = this.getDashboard(this.state.dashboard_id);
    // console.log("dashboard", dashboard);
    
    return (
      <div className="UserDashboard">
        {this.props.dashboards && this.props.dashboards.length > 1 ? (
          <UserDashboardDropdown
            {...this.props}
            {...this.state}
            onChangeDashboard={this.onChangeDashboard}
          />
        ) : null}
        <UserDashboardDisplay
          {...this.props}
          {...this.state}
          dashboard={dashboard}
          widgets={this.widgets}
        />
      </div>
    );
  }

  onChangeDashboard(e) {
    this.setState({ dashboard_id: e.target.value });
  }

  getDashboard(dashboard_id) {
    
    for (var i = 0, ilen = this.props.dashboards.length; i < ilen; i++) {
      var dashboard = this.props.dashboards[i];
      if (dashboard.id === dashboard_id) {
        return dashboard;
      }
    }
  }
}

export default UserDashboard;
